import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useRouterStore } from '~/components/hooks/RouterStore'
import { useCurrentUser } from '~/components/hooks/useCurrentUser'
import { UserRole } from '~/graphql/generated/query.types'

const IndexPage = () => {
  const router = useRouter()
  const routerStore = useRouterStore()
  const user = useCurrentUser()
  const isReportingViewer = user.role === UserRole.reportingViewer

  useEffect(() => {
    const defaultPath = isReportingViewer ? 'reports' : 'overview'
    const lastPathAllowed =
      routerStore.lastPath &&
      routerStore.validPaths.includes(routerStore.lastPath) &&
      (!isReportingViewer ||
        routerStore.lastPath === 'reports' ||
        routerStore.lastPath === 'settings')

    router
      .replace({
        pathname: lastPathAllowed ? routerStore.lastPath : defaultPath,
        query: isReportingViewer && !lastPathAllowed ? { view: 'metrics' } : undefined,
      })
      .catch(e => console.error(e))
  })
  return null // render nothing; redirect should show home
}

export default IndexPage
